import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitControlCompleteEditModel } from '@apps-common/types/portal/unit-control'

export const QUERY_KEY_MY_MONITORING_GET_CONTROL_FOR_EDIT = (controlId?: number) =>
  ['getMyMonitoringControlForEdit', controlId].filter(Boolean)

const getMyMonitoringControlForEdit = async (controlId: number): Promise<IUnitControlCompleteEditModel> =>
  axios.get(`/my-monitoring/control/GetControl?controlId=${controlId}`).then((res) => res.data?.data)

type QueryFnType = typeof getMyMonitoringControlForEdit

type Props = {
  config?: QueryConfig<QueryFnType>
  controlId: number
}

export const useMyMonitoringGetControlForEdit = ({ config, controlId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config },
    queryKey: QUERY_KEY_MY_MONITORING_GET_CONTROL_FOR_EDIT(controlId),
    queryFn: () => getMyMonitoringControlForEdit(controlId)
  })
